export function formatDuration(ms: number): string {
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor(ms / (1000 * 60 * 60));

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

    return parts.join(' ');
} 

export const formatDate = (input: string): string => {
  if (!input) return "N/A";

  try {
    const date = new Date(input);

    if (isNaN(date.getTime())) return "Invalid Date";

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // change to false if you want 24-hour format
    }).replace(/,/, "");

  } catch {
    return "Invalid Date";
  }
};


  export const formatTime = (input: string): string => {
  if (!input) return "N/A";
  try {
    const date = new Date(input);
    return isNaN(date.getTime())
      ? "Invalid Time"
      : date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
  } catch {
    return "Invalid Time";
  }
};